/**
 * Canonical on-disk layout for config-as-code in a user's repo.
 *
 * Config lives under a product-namespaced root at the repo's git root:
 *
 *   wayai-ws/
 *     org/                 # org-as-code (shared resources)
 *     hubs/<hub>/          # one folder per preview hub
 *     bases/<base>/        # one folder per preview base
 *     communities/<slug>/  # one folder per community (there is no preview)
 *
 * This is the single source of truth for the directory NAMES, shared between
 * the backend `download_workspace` endpoint and the CLI. The CLI imports this
 * directly and bundles it at build time (tsup `noExternal` inlines `@wayai/core`
 * into the shipped binary), spreading it into `apps/cli/src/lib/layout.ts`
 * `WAYAI_LAYOUT` alongside its legacy fallback.
 *
 * One descriptor, four subtrees — NOT one descriptor per product. `pull`/`push`
 * are single verbs that route by subtree and refuse an invocation spanning more
 * than one of `hubs/`, `bases/` and `communities/`.
 */
export const WAYAI_WORKSPACE_LAYOUT = {
  /** Product-namespaced root dir at the git root. */
  wsDir: 'wayai-ws',
  /** Subdir of `wsDir` holding hub folders. */
  hubsSubdir: 'hubs',
  /** Subdir of `wsDir` holding org-as-code. */
  orgSubdir: 'org',
  /** Subdir of `wsDir` holding base folders. */
  basesSubdir: 'bases',
  /** Subdir of `wsDir` holding community folders. */
  communitiesSubdir: 'communities',
} as const;
